import { PropsWithChildren } from "react";

export const ResponsiveTableBody = (props: PropsWithChildren<any>) => (
  <tbody>{props.children}</tbody>
);
